import { deleteRequest, getRequest, patchRequest, postRequest, putRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/shipment`;

const addBookmark = (id) => postRequest(`${baseURL}/${id}/bookmark`);
const createOffPlatformShipment = (payload) => postRequest(`${baseURL}/off-platform/create`, payload);
const cancelShipment = (id) => putRequest(`${baseURL}/${id}/cancel`);
const cancelAndDuplicateShipment = (id) => postRequest(`${baseURL}/${id}/cancel-and-duplicate`);
const createTrackingUpdate = (id, payload) => postRequest(`${baseURL}/trackings/${id}`, payload);
const disableShipmentNotifications = (id) => deleteRequest(`${baseURL}/${id}/notifications`);
const deleteBookmark = (id) => deleteRequest(`${baseURL}/${id}/bookmark`);
const enableShipmentNotifications = (id) => postRequest(`${baseURL}/${id}/notifications`, null);
const inviteGuestUser = (id, payload) => postRequest(`${baseURL}/${id}/invite`, payload);
const getBillOfLading = (id) => getRequest(`${baseURL}/${id}/bol`, { responseType: "blob" });
const getBookmarks = () => getRequest(`${baseURL}/bookmark`);
const getContainerUpdates = (id, trackingReferenceId) =>
  getRequest(`${baseURL}/${id}/tracking-references/${trackingReferenceId}/all-container-updates`);
const getGuestUsers = (id) => getRequest(`${baseURL}/${id}/invite`);
const getInTransitShipments = () => getRequest(`${baseURL}/all-in-transit-shipments`);
const getProviderPerformanceReview = (id) => getRequest(`${baseURL}/${id}/provider-performance-review`);
const getQuotationActionHistory = (id) => getRequest(`${baseURL}/${id}/quotation-action-history`);
const getShipment = (id) => getRequest(`${baseURL}/${id}`);
const getShipmentBasic = (id) => getRequest(`${baseURL}-basic/${id}`);
const getShipmentExceptions = () => getRequest(`${baseURL}/shipment-exceptions`);
const getShipments = (config = {}) => getRequest(`${baseURL}s`, config);
const getTrackingReferences = (id) => getRequest(`${baseURL}/${id}/tracking-references`);
const getTrackingUpdates = (id) => getRequest(`${baseURL}/geodata/${id}`);
const getVesselUpdates = (id, trackingReferenceId) =>
  getRequest(`${baseURL}/${id}/tracking-references/${trackingReferenceId}/schedule`);
const revokeGuestAccess = (id, inviteId) => deleteRequest(`${baseURL}/${id}/invite/${inviteId}`);
const submitPOD = (id, payload) => postRequest(`${baseURL}/${id}/add-pod`, payload);
const getPodBucketAttachments = (id, config = {}) => getRequest(`${baseURL}/${id}/pod-bucket-attachments`, config);
const createPodBucketAttachment = (id, payload) => postRequest(`${baseURL}/${id}/pod-bucket-attachments`, payload);
const deletePodBucketAttachment = (id, fileRef) =>
  deleteRequest(`${baseURL}/${id}/pod-bucket-attachments/${fileRef}`);
const submitPOP = (id, payload) => postRequest(`${baseURL}/${id}/add-pop`, payload);
const submitTrackingReferences = (id, payload) => postRequest(`${baseURL}/${id}/tracking-references`, payload);
const updateBookingReference = (id, payload) => putRequest(`${baseURL}/${id}/booking-reference`, payload);
const updateProviderPerformanceReview = (id, payload) => putRequest(`${baseURL}/${id}/provider-performance-review`, payload);
const updateTrackingReferences = (id, payload) => putRequest(`${baseURL}/${id}/tracking-references`, payload);
const getShipmentsByIds = (config = {}) => getRequest(`${baseURL}/get-by-ids`, config);
const imoprtOffPlatformShipments = (payload, config = {}) =>
  postRequest(`${REACT_APP_CARGOBASE_BASE_URL}/off-platform-shipment/import`, payload, config);
const getOffPlatformFieldSettings = (locationId) => getRequest(`${baseURL}/off-platform/${locationId}/settings`);
const getProviderCustomLabels = (id) => getRequest(`${baseURL}/${id}/custom-labels`);
const createAdditionalCost = (payload) => postRequest(`${baseURL}/additional-shipment-cost`, payload);
const deleteAdditionalCost = (id) => deleteRequest(`${baseURL}/additional-shipment-cost/${id}`);
const updateShipmentSchedule = (id, payload) => putRequest(`${baseURL}/${id}/schedule`, payload);
const updateShipmentDetails = (id, payload) => patchRequest(`${baseURL}/${id}`, payload);
const getShipmentSchedule = (id) => getRequest(`${baseURL}/${id}/schedule`);
const getDeliveryStopsPod = (id) => getRequest(`${baseURL}/${id}/delivery-stops-pod`);
const getShipmentAsGuestUser = (id) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/shipment-guest/${id}`);
const unsubscribeShipmentAsGuestUser = (id) =>
  putRequest(`${REACT_APP_CARGOBASE_BASE_URL}/shipment-guest/${id}/unsubscribe`);
const getAllAttachments = (id) =>
  getRequest(`${baseURL}/${id}/download-all-attachments`, {
    responseType: "blob",
  });
const deleteTrackingFile = (trackingId, config = {}) => deleteRequest(`${baseURL}/tracking-file/${trackingId}`, config);
const getPODAttachmentBuckets = (config = {}) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/pod-attachment-bucket`, config);
const regenerateTruckTrackingLink = (shipmentReference, trackingId) =>
  postRequest(`${baseURL}/${shipmentReference}/tracking-references/${trackingId}/regenerate`);

export {
  addBookmark,
  createOffPlatformShipment,
  createTrackingUpdate,
  cancelShipment,
  cancelAndDuplicateShipment,
  deleteBookmark,
  disableShipmentNotifications,
  enableShipmentNotifications,
  inviteGuestUser,
  getBillOfLading,
  getBookmarks,
  getContainerUpdates,
  getGuestUsers,
  getInTransitShipments,
  getProviderPerformanceReview,
  getQuotationActionHistory,
  getShipment,
  getShipmentAsGuestUser,
  unsubscribeShipmentAsGuestUser,
  getShipmentBasic,
  getShipmentExceptions,
  getShipments,
  getTrackingReferences,
  getTrackingUpdates,
  getVesselUpdates,
  revokeGuestAccess,
  submitPOD,
  getPodBucketAttachments,
  createPodBucketAttachment,
  deletePodBucketAttachment,
  submitPOP,
  submitTrackingReferences,
  updateBookingReference,
  updateProviderPerformanceReview,
  updateTrackingReferences,
  getShipmentsByIds,
  imoprtOffPlatformShipments,
  getOffPlatformFieldSettings,
  getProviderCustomLabels,
  createAdditionalCost,
  deleteAdditionalCost,
  updateShipmentSchedule,
  updateShipmentDetails,
  getShipmentSchedule,
  getDeliveryStopsPod,
  getAllAttachments,
  deleteTrackingFile,
  getPODAttachmentBuckets,
  regenerateTruckTrackingLink,
};
